import { CAPITAL_DEPOSIT_CONFIRMED_PARTNERS } from '@shinetools/capital-deposits-library';

import { authenticationEmitter, AuthenticationEvents } from 'helpers/auth';
import logger from 'helpers/logger';

import { PartnerShip } from '../../legacy/types';

export const LOCALSTORAGE_KEY = 'onboarding.partner';

export const getPartner = (): PartnerShip | null => {
  const partner = window.localStorage.getItem(LOCALSTORAGE_KEY);

  if (!partner) {
    return null;
  }
  return JSON.parse(partner) as PartnerShip;
};

export const clearPartner = (): void => {
  window.localStorage.removeItem(LOCALSTORAGE_KEY);
};

export const savePartner = (partner: PartnerShip): void => {
  if (partner !== undefined) {
    // The partner must be explicitly confirmed AND in the confirmed list
    const { isConfirmedPartner: confirmed, partner: name } = partner;
    const isConfirmedPartner = !!(
      Object.keys(CAPITAL_DEPOSIT_CONFIRMED_PARTNERS).includes(name) &&
      name &&
      confirmed
    );

    if (confirmed && !isConfirmedPartner) {
      logger.error(
        new Error(`The partner ${name} is not registered as confirmable`),
        { context: { partner } },
      );
    }

    window.localStorage.setItem(
      LOCALSTORAGE_KEY,
      JSON.stringify({
        isConfirmedPartner,
        partner: name,
      }),
    );
  }
};

authenticationEmitter.addListener(AuthenticationEvents.OnLogout, () => {
  clearPartner();
});
